import {
  string,
  object,
  array,
  enum_,
  union,
  null_,
  fallback,
  type InferOutput,
  safeParse,
} from 'valibot'
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
  KollegeUsersFilterAntiSocialStatus,
  KollegeUsersFilterUserStatus,
} from '@/types/schema.generated'

export const createInitialOkaneKollegeIndexPageFilterConditions = () => {
  return {
    userName: '',
    userStatuses: [],
    instructorIds: [],
    isAntiSocial: null,
  }
}

const initialCondition = createInitialOkaneKollegeIndexPageFilterConditions()
export const okaneKollegeIndexPageFilterConditionsSchema = object({
  userName: fallback(string(), initialCondition.userName),
  userStatuses: fallback(
    array(enum_(KollegeUsersFilterUserStatus)),
    initialCondition.userStatuses
  ),
  instructorIds: fallback(array(string()), initialCondition.instructorIds),
  isAntiSocial: fallback(
    union([enum_(KollegeUsersFilterAntiSocialStatus), null_()]),
    initialCondition.isAntiSocial
  ),
})

export type OkaneKollegeIndexPageFilterConditions = InferOutput<
  typeof okaneKollegeIndexPageFilterConditionsSchema
>

// 面倒なので一個のクエリパラメータにjsonで状態を突っ込む
const conditionsQueryParamKey = 'conditions'
export const parseConditionsFromQueryParam = (
  query: string | null
): OkaneKollegeIndexPageFilterConditions => {
  if (query == null) {
    return createInitialOkaneKollegeIndexPageFilterConditions()
  }

  try {
    const parsed = JSON.parse(query)
    const result = safeParse(
      okaneKollegeIndexPageFilterConditionsSchema,
      parsed
    )
    if (result.success) {
      return result.output
    }
  } catch {
    // ignore
  }
  return createInitialOkaneKollegeIndexPageFilterConditions()
}

export const useOkaneKollegeIndexPageFilterConditions = () => {
  const router = useRouter()
  const route = useRoute()

  const filterConditions = ref<OkaneKollegeIndexPageFilterConditions>(
    (() => {
      const jsonParsedConditions = (() => {
        const rawConditions = route.query[conditionsQueryParamKey]
        return Array.isArray(rawConditions) ? rawConditions[0] : rawConditions
      })()

      return parseConditionsFromQueryParam(jsonParsedConditions)
    })()
  )

  const submitSearch = () => {
    router.replace({
      query: {
        [conditionsQueryParamKey]: JSON.stringify(filterConditions.value),
      },
    })
  }

  const resetSearch = () => {
    filterConditions.value =
      createInitialOkaneKollegeIndexPageFilterConditions()
    router.replace({
      query: {},
    })
  }

  return {
    filterConditions,
    submitSearch,
    resetSearch,
  }
}
